import 'devextreme/ui/drop_down_box';
import Currency, { CurrencyProps } from './Currency';
import Image, { ImageProps } from './Image';
import RelatedItems, { RelatedItemsProps } from './RelatedItems';
import RelatedItemsCards, { RelatedItemsCardsProps } from './RelatedItemsCards';
import React from 'react';
import { EditorProps } from './EditorProps';
import SplitButton, { SplitButtonProps } from './SplitButton';

export type NuvoEditorTypeProps =
  | ImageProps
  | CurrencyProps
  | RelatedItemsProps
  | RelatedItemsCardsProps
  | SplitButtonProps;

export type NuvoEditorType = NuvoEditorTypeProps['editorType'];

const editors = {
  Image,
  Currency,
  RelatedItems,
  RelatedItemsCards,
  SplitButton,
} satisfies Record<NuvoEditorType, React.NamedExoticComponent<EditorProps<any>>>;

export default editors;
